module.exports = __webpack_public_path__ + "img/ua.2a9d5b21.svg";